import React from 'react'
import { Grid, styled } from '@mui/material'

export const Container = styled(({ ...other }) => (<Grid container {...other} />))({})

export const Item = styled(({ ...other }) => (<Grid item {...other} />))({})
